export default "__VITE_ASSET__DVDBGPAV__"